import { get } from 'axios'

export default {
    actions: {
        async getPositions(ctx, params = {}) {
            if (ctx.state.positions.length) return Promise.resolve(ctx.state.positions)
            console.time('Load positions time')

            const request = await get('/api/global/Position')

            const label = `[vuex] [global] Get positions [${request.data.Data.length}]`;
            console.groupCollapsed(label);
            console.info(request.data.Data);
            console.timeEnd('Load positions time')
            console.groupEnd(label);

            ctx.commit('updatePositions', request.data.Data)
        }
    },
    mutations: {
        updatePositions(state, positions) {
            state.positions = positions
        },
    },
    state: {
        positions: [],
    },
    getters: {
        allPositions(state) {
            return state.positions
        },
    },
}